import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import ProductCard from '@nmx/template/dist/componentLibrary/modules/ProductCard';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import HomeSafeLocked from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/HomeSafeLocked';
import PaperWithDollarSignAndBarChart from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/PaperWithDollarSignAndBarChart';
import StopwatchWithDollarSign from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/StopwatchWithDollarSign';
// styles
import { ColStyled } from './styles';

export default () => (
  <SectionContainer
    id='non-qualified-retirement-plan-product-callout-grouping-1'
    backgroundVariant='lightB'
    themeType='lightTheme'
    moduleName='product-callout-grouping-module'
    moduleVariation='A'
    disableBottomPadding>
    <Row align='center'>
      <Col
        medium={10}
        large={8}>
        <Typography
          align='center'
          component='h2'
          nextElement='typography'>
          Types of non&#45;qualified <WidowBlock>retirement plans</WidowBlock>
        </Typography>
        <Typography nextElement='graphic'>
          Retirement accounts like a&nbsp;
          <Link
            id='non-qualified-retirement-plan-401k-link'
            variant='primaryDeemphasize'
            linkUrl='/401k-plans/'
            ariaLabel='401k plans'>
            401(k)
          </Link>
          &nbsp;and&nbsp;
          <Link
            id='non-qualified-retirement-plan-ira-link'
            variant='primaryDeemphasize'
            linkUrl='/iras-and-retirement-plans/'
            ariaLabel='IRAs and retirement plans'>
            IRA
          </Link>
          &nbsp;are well known, but when it comes to non&#45;qualified retirement plans, not so much. Here are several common ones:
        </Typography>
      </Col>
    </Row>
    <Row align='left'>
      <ColStyled
        medium={6}
        large={4}>
        <ProductCard
          cardId='product-callout-non-qualified-retirement-plan-compensation-plan'
          icon={HomeSafeLocked}
          backgroundVariant='lightA'
          cardHeading={<>Elective Deferred <WidowBlock>Compensation Plan</WidowBlock></>}
          cardText='This plan allows a key employee to take a portion of their yearly wages and defer it to sometime down the road, most often during retirement.'
        />
      </ColStyled>
      <ColStyled
        medium={6}
        large={4}>
        <ProductCard
          cardId='product-callout-non-qualified-retirement-plan-serp'
          icon={StopwatchWithDollarSign}
          backgroundVariant='lightA'
          cardHeading={<>Supplemental Executive Retirement <WidowBlock>Plan (SERP)</WidowBlock></>}
          cardText='The employer or business owner agrees to set aside additional compensation for a key employee and promises to pay it later, typically when they leave the company or retire.'
        />
      </ColStyled>
      <ColStyled
        medium={6}
        large={4}
        disableBottomMargin>
        <ProductCard
          cardId='product-callout-non-qualified-retirement-plan-phantom-stock-plan'
          icon={PaperWithDollarSignAndBarChart}
          backgroundVariant='lightA'
          cardHeading='Phantom Stock Plan'
          cardText={
            <>
              This cash benefit is a performance&#45;based arrangement that pays a key employee either the value of a specified number of company stock shares or the growth in the value of the stock.
            </>
          }
        />
      </ColStyled>
    </Row>
  </SectionContainer>
);
